import { createReducer, on } from '@ngrx/store';
import { MenuItem, CartTotals } from '@core/models';
import {
  CART_FIND_BY_ID_SUCCESS,
  CART_UPDATE_FORM,
  CART_FIND_SUCCESS,
  CART_UPDATE_TOTALS,
  CART_RESET_FORM,
  CART_RESET_STATE
} from '@store/actions'

export interface CartState {
  items: MenuItem[];
  cart: MenuItem | null;
  cartForm: MenuItem | null;
  cartTotals: CartTotals;
  subtotal: bigint;
  discount: bigint;
  deliveryCharge: bigint;
  total: bigint;
  error: string | null;
}

const initialState: CartState = {
  items: [],
  cart: null,
  cartForm: null,
  cartTotals: {
    subtotal: 0n,
    taxes: 0n,
    total: 0n,
    couponDiscount: 0n,
    tip: 0n,
    deliveryCharges: 0n,
    totalCash: 0n
  },
  subtotal: 0n,
  discount: 0n,
  deliveryCharge: 900000n,
  total: 0n,
  error: null
};

export const cartReducer = createReducer(
  initialState,
  on(CART_FIND_SUCCESS, (state, { items }) => ({ ...state, items })),
  on(CART_FIND_BY_ID_SUCCESS, (state, { cart }) => ({ ...state, cart })),
  on(CART_UPDATE_FORM, (state, { cartForm }) => ({ ...state, cartForm })),
  on(CART_UPDATE_TOTALS, (state, { cartTotals }) => ({ ...state, cartTotals })),
  on(CART_RESET_FORM, (state) => ({ ...state, cartForm: null })),  
  on(CART_RESET_STATE, (state) => ({ ...state, items: [] })),  
)
